import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { commonCopySourceAdapts } from './copysource.adapter';
import { SqlDWCopySourceAdapter } from './sqldw.copysource.adapter';
import { DataWarehouseCopySource } from 'app/model/pipeline/copysource/data-warehouse.copysource';
import { IModel } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DataWarehouseCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        sqlReaderQuery: '*',
        sqlReaderStoredProcedureName: '*',
        storedProcedureParameters: '*',
        queryTimeout: '*',
        isolationLevel: '*',
        partitionOption: '*',
        partitionSettings: {
            partitionColumnName: '*',
            partitionUpperBound: '*',
            partitionLowerBound: '*'
        }
    }
})
export class DataWarehouseCopySourceAdapter extends SqlDWCopySourceAdapter {
    protected override model(): IModel {
        return DataWarehouseCopySource.MODEL;
    }
}
